import { useEffect } from 'react';
import GoogleLoginButton from '../GoogleLoginButton';
import './index.css';

// Google OAuth Provider is configured in App.tsx

export const GoogleAuth = () => {
  useEffect(() => {
    // gapi is not required when using @react-oauth/google
  }, []);

  return (
    <div className="google-auth-block">
      <GoogleLoginButton />
    </div>
  );
};
